import React from 'react';
import PropTypes from 'prop-types';
import Component from '@ux/component';
import { ICONS } from './constants';

/**
 * Alert header.
 *
 * The header is the main part of the alert, showing the icon, the heading message,
 * and the main alert message contents.
 *
 * @class Header
 * @public
 */
export default class Header extends Component {
  /**
   * Render the alert header.
   *
   * @returns {ReactElement} div
   * @public
   */
  render() {
    const iconClass = ICONS[this.props.icon] || this.props.icon;
    const classNames = ['alert-icon', 'uxicon', iconClass].join(' ');

    return (
      <div className='alert-text-wrap'>
        <div className={ classNames } aria-hidden='true'></div>
        <strong className='headline-primary' role='heading' aria-level='1'>{ this.props.heading }</strong> { this.props.children }
      </div>
    );
  }
}

/**
 * Property types.
 *
 * @type {Object}
 * @private
 */
Header.propTypes = {
  /** The icon image and class to use */
  icon: PropTypes.string,
  /** The alert message heading */
  heading: PropTypes.node,
  /** The alert message contents */
  children: PropTypes.node
};
